// i18nOwl-ignore [app-cohort.triggerIntegrations.digital-asset-owned.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import CohortDigitalAssetOwnedTriggerkIntegrationConfigComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/digitalAssetOwned/ConfigComponent';
import CohortDigitalAssetOwnedTriggerIntegrationStepCompletionComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/digitalAssetOwned/StepCompletionComponent';
import type {CohortDigitalAssetOwnedTriggerStruct} from '@cohort/shared/schema/apps/cohort/triggers/digitalAssetOwned';
import {CohortDigitalAssetOwnedTriggerIntegrationSpec} from '@cohort/shared/schema/apps/cohort/triggers/digitalAssetOwned';

export const CohortDigitalAssetOwnedTriggerIntegration: TriggerIntegration<CohortDigitalAssetOwnedTriggerStruct> =
  {
    spec: CohortDigitalAssetOwnedTriggerIntegrationSpec,
    configComponent: CohortDigitalAssetOwnedTriggerkIntegrationConfigComponent,
    stepCompletionComponent: CohortDigitalAssetOwnedTriggerIntegrationStepCompletionComponent,
  };
